import { createContext, ReactNode, useContext, useReducer } from "react";
import { CreateArworkReducer } from "../../../state/collection/create";
import { InitialContext } from "../../../../../types/state/context";
import {
  CreateArtworkCollectionState,
  CreateArtworkCollectionTypes,
} from "../../../state/collection/create/data";

type Context = InitialContext<
  CreateArtworkCollectionState,
  CreateArtworkCollectionTypes
>;
export const CreateArtworkCollectionContext = createContext<Context>(
  {} as Context,
);

export const CreateArtworkCollectionProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(
    CreateArworkReducer.reducer,
    CreateArworkReducer.initialState,
  );

  return (
    <CreateArtworkCollectionContext.Provider value={{ state, dispatch }}>
      {children}
    </CreateArtworkCollectionContext.Provider>
  );
};

export const useCreateArtworkCollectionStore = () =>
  useContext(CreateArtworkCollectionContext);
